﻿/**
 * Generated from data/raw/timetable/T0402时刻表.pdf and enriched with confirmed operating arrangements.
 * Status: confirmed by the user on 2026-08-05.
 */
export const T0402_TIMETABLE = 
{
    "status":  "confirmed",
    "review":  {
                    "confirmedOn":  "2026-08-05",
                    "confirmedBy":  "user",
                    "scope":  "PDF transcription, 52 revenue trips, four circulations and 62 links, endpoint turnback-context interpretation"
                },
    "source":  {
                   "file":  "data/raw/timetable/T0402时刻表.pdf",
                   "sha256":  "975d57e01db557728cb12f292868edaeb2a586495fca428e3c29945f2268fdfa",
                   "pages":  4,
                   "extractedOn":  "2026-08-05",
                   "extraction":  "PDF embedded text coordinates plus visual page review"
               },
    "conventions":  {
                        "directionDown":  "翔安机场站 -\u003e 集美软件园北站",
                        "directionUp":  "集美软件园北站 -\u003e 翔安机场站",
                        "timeZone":  "Asia/Shanghai",
                        "timePrecision":  "second",
                        "endpointExtraTimes":  "turnback context, not part of the current trip stop time",
                        "classification":  "Revenue, non-revenue, and mixed-service roles follow the PDF plus the user-confirmed T0402 operating arrangements; no trip classification remains unconfirmed.",
                        "vehicleIdentity":  "A circulation/vehicleId persists across trip-number changes.",
                        "depotVisualization":  "Houxi depot is a non-revenue boundary. Train diagrams show it as a branch after Houxi; map simulation follows the imported Houxi depot branch geometry from the GeoHub export.",
                        "nonRevenueNotice":  "非载客车次的前方到站信息必须附注“本次列车不载客”。"
                    },
    "locations":  [
                      {
                          "name":  "翔安机场站",
                          "id":  "xiangan-airport",
                          "kind":  "station",
                          "operational":  true
                      },
                      {
                          "name":  "机场西站(预留)",
                          "id":  "airport-west-reserved",
                          "kind":  "reserved-pass",
                          "operational":  false,
                          "displayLabel":  "机场西站（预留·非运营）",
                          "mapStyle":  "reserved-non-operational"
                      },
                      {
                          "name":  "洞庭站",
                          "id":  "dongting",
                          "kind":  "station",
                          "operational":  true
                      },
                      {
                          "name":  "前浯站",
                          "id":  "qianwu",
                          "kind":  "station",
                          "operational":  true
                      },
                      {
                          "name":  "洪坑站",
                          "id":  "hongkeng",
                          "kind":  "station",
                          "operational":  true
                      },
                      {
                          "name":  "西岩站",
                          "id":  "xiyan",
                          "kind":  "station",
                          "operational":  true
                      },
                      {
                          "name":  "城场站",
                          "id":  "chengchang",
                          "kind":  "station",
                          "operational":  true
                      },
                      {
                          "name":  "丙洲站",
                          "id":  "bingzhou",
                          "kind":  "station",
                          "operational":  true
                      },
                      {
                          "name":  "官浔站",
                          "id":  "guanxun",
                          "kind":  "station",
                          "operational":  true
                      },
                      {
                          "name":  "厦门北站",
                          "id":  "xiamen-north",
                          "kind":  "station",
                          "operational":  true
                      },
                      {
                          "name":  "后溪站",
                          "id":  "houxi",
                          "kind":  "station",
                          "operational":  true
                      },
                      {
                          "name":  "后溪车辆段",
                          "id":  "houxi-depot",
                          "kind":  "depot",
                          "operational":  false,
                          "displayLabel":  "后溪车辆段",
                          "displayOnMap":  true,
                          "displayInStationList":  false
                      },
                      {
                          "name":  "集美软件园北站",
                          "id":  "jimei-software-park-north",
                          "kind":  "station",
                          "operational":  true
                      }
                  ],
    "trips":  [
                  {
                      "tripId":  "00407",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  1,
                      "sourceColumn":  1,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "10:15:31",
                                                          "10:16:21"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "departure":  "10:16:21",
                                         "turnbackContextBefore":  "10:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "10:16:48"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "10:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "10:23:18",
                                                          "10:23:48"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "10:23:18",
                                         "departure":  "10:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "10:26:13",
                                                          "10:26:43"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "10:26:13",
                                         "departure":  "10:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "10:29:59",
                                                          "10:30:39"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "10:29:59",
                                         "departure":  "10:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "10:32:46",
                                                          "10:33:16"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "10:32:46",
                                         "departure":  "10:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "10:37:15",
                                                          "10:37:45"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "10:37:15",
                                         "departure":  "10:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "10:40:53",
                                                          "10:41:23"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "10:40:53",
                                         "departure":  "10:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "10:44:03",
                                                          "10:44:33"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "10:44:03",
                                         "departure":  "10:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "10:50:03",
                                                          "10:50:43"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "10:50:03",
                                         "departure":  "10:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "10:53:19",
                                                          "10:53:49"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "10:53:19",
                                         "departure":  "10:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "10:55:50"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "arrival":  "10:55:50"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00105",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  1,
                      "sourceColumn":  2,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "09:45:31",
                                                          "09:46:21"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "departure":  "09:46:21",
                                         "turnbackContextBefore":  "09:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "09:46:48"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "09:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "09:53:18",
                                                          "09:53:48"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "09:53:18",
                                         "departure":  "09:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "09:56:13",
                                                          "09:56:43"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "09:56:13",
                                         "departure":  "09:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "09:59:59",
                                                          "10:00:39"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "09:59:59",
                                         "departure":  "10:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "10:02:46",
                                                          "10:03:16"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "10:02:46",
                                         "departure":  "10:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "10:07:15",
                                                          "10:07:45"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "10:07:15",
                                         "departure":  "10:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "10:10:53",
                                                          "10:11:23"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "10:10:53",
                                         "departure":  "10:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "10:14:03",
                                                          "10:14:33"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "10:14:03",
                                         "departure":  "10:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "10:20:03",
                                                          "10:20:43"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "10:20:03",
                                         "departure":  "10:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "10:23:19",
                                                          "10:23:49"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "10:23:19",
                                         "departure":  "10:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "10:25:50"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "arrival":  "10:25:50"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00205",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  1,
                      "sourceColumn":  3,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "09:15:31",
                                                          "09:16:21"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "departure":  "09:16:21",
                                         "turnbackContextBefore":  "09:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "09:16:48"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "09:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "09:23:18",
                                                          "09:23:48"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "09:23:18",
                                         "departure":  "09:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "09:26:13",
                                                          "09:26:43"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "09:26:13",
                                         "departure":  "09:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "09:29:59",
                                                          "09:30:39"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "09:29:59",
                                         "departure":  "09:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "09:32:46",
                                                          "09:33:16"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "09:32:46",
                                         "departure":  "09:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "09:37:15",
                                                          "09:37:45"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "09:37:15",
                                         "departure":  "09:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "09:40:53",
                                                          "09:41:23"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "09:40:53",
                                         "departure":  "09:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "09:44:03",
                                                          "09:44:33"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "09:44:03",
                                         "departure":  "09:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "09:50:03",
                                                          "09:50:43"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "09:50:03",
                                         "departure":  "09:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "09:53:19",
                                                          "09:53:49"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "09:53:19",
                                         "departure":  "09:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "09:55:50"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "arrival":  "09:55:50"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00405",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  1,
                      "sourceColumn":  4,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "08:45:31",
                                                          "08:46:21"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "departure":  "08:46:21",
                                         "turnbackContextBefore":  "08:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "08:46:48"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "08:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "08:53:18",
                                                          "08:53:48"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "08:53:18",
                                         "departure":  "08:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "08:56:13",
                                                          "08:56:43"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "08:56:13",
                                         "departure":  "08:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "08:59:59",
                                                          "09:00:39"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "08:59:59",
                                         "departure":  "09:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "09:02:46",
                                                          "09:03:16"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "09:02:46",
                                         "departure":  "09:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "09:07:15",
                                                          "09:07:45"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "09:07:15",
                                         "departure":  "09:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "09:10:53",
                                                          "09:11:23"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "09:10:53",
                                         "departure":  "09:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "09:14:03",
                                                          "09:14:33"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "09:14:03",
                                         "departure":  "09:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "09:20:03",
                                                          "09:20:43"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "09:20:03",
                                         "departure":  "09:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "09:23:19",
                                                          "09:23:49"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "09:23:19",
                                         "departure":  "09:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "09:25:50"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "arrival":  "09:25:50"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00305",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  1,
                      "sourceColumn":  5,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "08:22:20",
                                                          "08:23:10"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "departure":  "08:23:10",
                                         "turnbackContextBefore":  "08:22:20"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "08:23:37"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "08:23:37"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "08:30:07",
                                                          "08:30:37"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "08:30:07",
                                         "departure":  "08:30:37"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "08:33:02",
                                                          "08:33:32"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "08:33:02",
                                         "departure":  "08:33:32"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "08:36:48",
                                                          "08:37:28"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "08:36:48",
                                         "departure":  "08:37:28"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "08:39:35",
                                                          "08:40:05"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "08:39:35",
                                         "departure":  "08:40:05"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "08:44:04",
                                                          "08:44:34"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "08:44:04",
                                         "departure":  "08:44:34"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "08:47:42",
                                                          "08:48:12"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "08:47:42",
                                         "departure":  "08:48:12"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "08:50:52",
                                                          "08:51:22"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "08:50:52",
                                         "departure":  "08:51:22"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "08:56:52",
                                                          "08:57:32"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "08:56:52",
                                         "departure":  "08:57:32"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "09:00:08",
                                                          "09:00:38"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "09:00:08",
                                         "departure":  "09:00:38"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "09:02:39"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "arrival":  "09:02:39"
                                     }
                                 ],
                      "circulationId":  "C003",
                      "vehicleId":  "trainset-003",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00103",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  1,
                      "sourceColumn":  6,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "07:57:00",
                                                          "08:00:00"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "departure":  "08:00:00",
                                         "turnbackContextBefore":  "07:57:00"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "08:00:27"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "08:00:27"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "08:06:57",
                                                          "08:07:27"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "08:06:57",
                                         "departure":  "08:07:27"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "08:09:52",
                                                          "08:10:22"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "08:09:52",
                                         "departure":  "08:10:22"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "08:13:38",
                                                          "08:14:18"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "08:13:38",
                                         "departure":  "08:14:18"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "08:16:25",
                                                          "08:16:55"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "08:16:25",
                                         "departure":  "08:16:55"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "08:20:54",
                                                          "08:21:24"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "08:20:54",
                                         "departure":  "08:21:24"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "08:24:32",
                                                          "08:25:02"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "08:24:32",
                                         "departure":  "08:25:02"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "08:27:58",
                                                          "08:28:28"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "08:27:58",
                                         "departure":  "08:28:28"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "08:34:31",
                                                          "08:35:11"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "08:34:31",
                                         "departure":  "08:35:11"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "08:38:03",
                                                          "08:38:33"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "08:38:03",
                                         "departure":  "08:38:33"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "08:40:47"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "arrival":  "08:40:47"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00403",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  1,
                      "sourceColumn":  7,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "07:53:59"
                                                      ],
                                         "sourceY":  [
                                                         390.568
                                                     ],
                                         "departure":  "07:53:59"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "07:56:00"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "arrival":  "07:56:00"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "non-revenue",
                      "movementType":  "non-revenue-transition"
                  },
                  {
                      "tripId":  "00203",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  1,
                      "sourceColumn":  8,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "07:48:54"
                                                      ],
                                         "sourceY":  [
                                                         243.68
                                                     ],
                                         "departure":  "07:48:54"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "07:51:01"
                                                      ],
                                         "sourceY":  [
                                                         262.048
                                                     ],
                                         "pass":  "07:51:01"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "07:55:00",
                                                          "08:00:00"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "07:55:00",
                                         "departure":  "08:00:00"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "08:03:08",
                                                          "08:03:38"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "08:03:08",
                                         "departure":  "08:03:38"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "08:06:18",
                                                          "08:06:48"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "08:06:18",
                                         "departure":  "08:06:48"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "08:12:18",
                                                          "08:12:58"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "08:12:18",
                                         "departure":  "08:12:58"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "08:15:34",
                                                          "08:16:04"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "08:15:34",
                                         "departure":  "08:16:04"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "08:18:05"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "arrival":  "08:18:05"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "mixed",
                      "movementType":  "partial-passenger-service",
                      "serviceSegments":  [
                                              {
                                                  "classification":  "non-revenue",
                                                  "fromLocationId":  "hongkeng",
                                                  "departure":  "07:48:54",
                                                  "toLocationId":  "chengchang",
                                                  "arrival":  "07:55:00"
                                              },
                                              {
                                                  "classification":  "revenue",
                                                  "fromLocationId":  "chengchang",
                                                  "departure":  "08:00:00",
                                                  "toLocationId":  "jimei-software-park-north",
                                                  "arrival":  "08:18:05"
                                              }
                                          ],
                      "serviceTransition":  {
                                                "locationId":  "chengchang",
                                                "arrival":  "07:55:00",
                                                "departure":  "08:00:00",
                                                "state":  "boarding-before-revenue-service"
                                            }
                  },
                  {
                      "tripId":  "00303",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  1,
                      "sourceColumn":  9,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "07:08:29"
                                                      ],
                                         "sourceY":  [
                                                         390.568
                                                     ],
                                         "departure":  "07:08:29"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "07:10:57"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "arrival":  "07:10:57"
                                     }
                                 ],
                      "circulationId":  "C003",
                      "vehicleId":  "trainset-003",
                      "classification":  "non-revenue",
                      "movementType":  "rail-inspection"
                  },
                  {
                      "tripId":  "00101",
                      "direction":  "down",
                      "destinationCode":  "166",
                      "sourcePage":  1,
                      "sourceColumn":  10,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "06:50:49",
                                                          "06:51:09"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "departure":  "06:51:09",
                                         "turnbackContextBefore":  "06:50:49"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "06:52:08"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "06:52:08"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "07:06:07"
                                                      ],
                                         "sourceY":  [
                                                         188.604
                                                     ],
                                         "pass":  "07:06:07"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "07:10:18"
                                                      ],
                                         "sourceY":  [
                                                         213.076
                                                     ],
                                         "pass":  "07:10:18"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "07:15:06"
                                                      ],
                                         "sourceY":  [
                                                         237.548
                                                     ],
                                         "arrival":  "07:15:06"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "non-revenue",
                      "movementType":  "rail-inspection"
                  },
                  {
                      "tripId":  "00202",
                      "direction":  "up",
                      "destinationCode":  "161",
                      "sourcePage":  1,
                      "sourceColumn":  1,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "07:39:45"
                                                      ],
                                         "sourceY":  [
                                                         243.68
                                                     ],
                                         "arrival":  "07:39:45"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "07:36:19"
                                                      ],
                                         "sourceY":  [
                                                         262.048
                                                     ],
                                         "pass":  "07:36:19"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "07:28:27"
                                                      ],
                                         "sourceY":  [
                                                         286.52
                                                     ],
                                         "pass":  "07:28:27"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "07:22:24"
                                                      ],
                                         "sourceY":  [
                                                         310.992
                                                     ],
                                         "pass":  "07:22:24"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "07:17:40"
                                                      ],
                                         "sourceY":  [
                                                         335.464
                                                     ],
                                         "pass":  "07:17:40"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "07:05:33"
                                                      ],
                                         "sourceY":  [
                                                         359.964
                                                     ],
                                         "pass":  "07:05:33"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "07:01:00"
                                                      ],
                                         "sourceY":  [
                                                         384.436
                                                     ],
                                         "departure":  "07:01:00"
                                     },
                                     {
                                         "locationId":  "houxi-depot",
                                         "rawTimes":  [
                                                          "07:00:00"
                                                      ],
                                         "sourceY":  [
                                                         402.804
                                                     ],
                                         "boundaryTime":  "07:00:00",
                                         "markers":  [
                                                         "▲G1011"
                                                     ]
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "non-revenue",
                      "movementType":  "depot-outbound-and-reverse-rail-inspection",
                      "operationalTrack":  "down",
                      "movementDirection":  "reverse",
                      "pdfDisplayDirection":  "up"
                  },
                  {
                      "tripId":  "00302",
                      "direction":  "up",
                      "destinationCode":  "101",
                      "sourcePage":  1,
                      "sourceColumn":  2,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "07:06:00"
                                                      ],
                                         "sourceY":  [
                                                         390.568
                                                     ],
                                         "pass":  "07:06:00"
                                     },
                                     {
                                         "locationId":  "houxi-depot",
                                         "rawTimes":  [
                                                          "07:05:00"
                                                      ],
                                         "sourceY":  [
                                                         402.804
                                                     ],
                                         "boundaryTime":  "07:05:00",
                                         "markers":  [
                                                         "▲G1010"
                                                     ]
                                     }
                                 ],
                      "circulationId":  "C003",
                      "vehicleId":  "trainset-003",
                      "classification":  "non-revenue",
                      "movementType":  "depot-outbound"
                  },
                  {
                      "tripId":  "00304",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  1,
                      "sourceColumn":  3,
                      "classificationHint":  "full-line-outside-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "08:09:11",
                                                          "08:08:41"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "arrival":  "08:08:41",
                                         "turnbackContextAfter":  "08:09:11"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "08:08:12"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "08:08:12"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "08:00:58"
                                                      ],
                                         "sourceY":  [
                                                         188.604
                                                     ],
                                         "pass":  "08:00:58"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "07:58:18"
                                                      ],
                                         "sourceY":  [
                                                         213.076
                                                     ],
                                         "pass":  "07:58:18"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "07:54:50"
                                                      ],
                                         "sourceY":  [
                                                         237.548
                                                     ],
                                         "pass":  "07:54:50"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "07:51:27"
                                                      ],
                                         "sourceY":  [
                                                         262.048
                                                     ],
                                         "pass":  "07:51:27"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "07:43:35"
                                                      ],
                                         "sourceY":  [
                                                         286.52
                                                     ],
                                         "pass":  "07:43:35"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "07:37:32"
                                                      ],
                                         "sourceY":  [
                                                         310.992
                                                     ],
                                         "pass":  "07:37:32"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "07:32:48"
                                                      ],
                                         "sourceY":  [
                                                         335.464
                                                     ],
                                         "pass":  "07:32:48"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "07:20:41"
                                                      ],
                                         "sourceY":  [
                                                         359.964
                                                     ],
                                         "pass":  "07:20:41"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "07:16:08"
                                                      ],
                                         "sourceY":  [
                                                         384.436
                                                     ],
                                         "pass":  "07:16:08"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "07:13:54"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "departure":  "07:13:54"
                                     }
                                 ],
                      "circulationId":  "C003",
                      "vehicleId":  "trainset-003",
                      "classification":  "non-revenue",
                      "movementType":  "rail-inspection"
                  },
                  {
                      "tripId":  "00102",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  1,
                      "sourceColumn":  4,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "07:42:48",
                                                          "07:42:28"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "arrival":  "07:42:28",
                                         "turnbackContextAfter":  "07:42:48"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "07:41:29"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "07:41:29"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "07:27:30"
                                                      ],
                                         "sourceY":  [
                                                         188.604
                                                     ],
                                         "pass":  "07:27:30"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "07:23:19"
                                                      ],
                                         "sourceY":  [
                                                         213.076
                                                     ],
                                         "pass":  "07:23:19"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "07:18:31"
                                                      ],
                                         "sourceY":  [
                                                         237.548
                                                     ],
                                         "departure":  "07:18:31"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "non-revenue",
                      "movementType":  "rail-inspection"
                  },
                  {
                      "tripId":  "00402",
                      "direction":  "up",
                      "destinationCode":  "101",
                      "sourcePage":  1,
                      "sourceColumn":  5,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "07:51:00"
                                                      ],
                                         "sourceY":  [
                                                         390.568
                                                     ],
                                         "pass":  "07:51:00"
                                     },
                                     {
                                         "locationId":  "houxi-depot",
                                         "rawTimes":  [
                                                          "07:47:00"
                                                      ],
                                         "sourceY":  [
                                                         402.804
                                                     ],
                                         "boundaryTime":  "07:47:00",
                                         "markers":  [
                                                         "▲G1011"
                                                     ]
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "non-revenue",
                      "movementType":  "depot-outbound"
                  },
                  {
                      "tripId":  "00404",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  1,
                      "sourceColumn":  6,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "08:39:59",
                                                          "08:39:09"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "arrival":  "08:39:09",
                                         "turnbackContextAfter":  "08:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "08:38:43"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "08:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "08:32:09",
                                                          "08:31:39"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "08:31:39",
                                         "departure":  "08:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "08:29:14",
                                                          "08:28:44"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "08:28:44",
                                         "departure":  "08:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "08:25:35",
                                                          "08:24:55"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "08:24:55",
                                         "departure":  "08:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "08:22:44",
                                                          "08:22:14"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "08:22:14",
                                         "departure":  "08:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "08:18:15",
                                                          "08:17:45"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "08:17:45",
                                         "departure":  "08:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "08:14:36",
                                                          "08:14:06"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "08:14:06",
                                         "departure":  "08:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "08:11:27",
                                                          "08:10:57"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "08:10:57",
                                         "departure":  "08:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "08:05:28",
                                                          "08:04:48"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "08:04:48",
                                         "departure":  "08:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "08:02:15",
                                                          "08:01:45"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "08:01:45",
                                         "departure":  "08:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "08:00:00"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "departure":  "08:00:00"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00204",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  1,
                      "sourceColumn":  7,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "09:02:29",
                                                          "09:01:39"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "arrival":  "09:01:39",
                                         "turnbackContextAfter":  "09:02:29"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "09:01:13"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "09:01:13"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "08:54:39",
                                                          "08:54:09"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "08:54:09",
                                         "departure":  "08:54:39"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "08:51:44",
                                                          "08:51:14"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "08:51:14",
                                         "departure":  "08:51:44"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "08:48:05",
                                                          "08:47:25"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "08:47:25",
                                         "departure":  "08:48:05"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "08:45:14",
                                                          "08:44:44"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "08:44:44",
                                         "departure":  "08:45:14"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "08:40:45",
                                                          "08:40:15"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "08:40:15",
                                         "departure":  "08:40:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "08:37:06",
                                                          "08:36:36"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "08:36:36",
                                         "departure":  "08:37:06"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "08:33:57",
                                                          "08:33:27"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "08:33:27",
                                         "departure":  "08:33:57"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "08:27:58",
                                                          "08:27:18"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "08:27:18",
                                         "departure":  "08:27:58"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "08:24:45",
                                                          "08:24:15"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "08:24:15",
                                         "departure":  "08:24:45"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "08:22:30"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "departure":  "08:22:30"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00104",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  1,
                      "sourceColumn":  8,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "09:24:59",
                                                          "09:24:09"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "arrival":  "09:24:09",
                                         "turnbackContextAfter":  "09:24:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "09:23:43"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "09:23:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "09:17:09",
                                                          "09:16:39"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "09:16:39",
                                         "departure":  "09:17:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "09:14:14",
                                                          "09:13:44"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "09:13:44",
                                         "departure":  "09:14:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "09:10:35",
                                                          "09:09:55"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "09:09:55",
                                         "departure":  "09:10:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "09:07:44",
                                                          "09:07:14"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "09:07:14",
                                         "departure":  "09:07:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "09:03:15",
                                                          "09:02:45"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "09:02:45",
                                         "departure":  "09:03:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "08:59:36",
                                                          "08:59:06"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "08:59:06",
                                         "departure":  "08:59:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "08:56:27",
                                                          "08:55:57"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "08:55:57",
                                         "departure":  "08:56:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "08:50:28",
                                                          "08:49:48"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "08:49:48",
                                         "departure":  "08:50:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "08:47:15",
                                                          "08:46:45"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "08:46:45",
                                         "departure":  "08:47:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "08:45:00"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "departure":  "08:45:00"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00306",
                      "direction":  "up",
                      "destinationCode":  "203",
                      "sourcePage":  1,
                      "sourceColumn":  9,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "09:47:29",
                                                          "09:46:39"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "arrival":  "09:46:39",
                                         "turnbackContextAfter":  "09:47:29"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "09:46:13"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "09:46:13"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "09:39:39",
                                                          "09:39:09"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "09:39:09",
                                         "departure":  "09:39:39"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "09:36:44",
                                                          "09:36:14"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "09:36:14",
                                         "departure":  "09:36:44"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "09:33:05",
                                                          "09:32:25"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "09:32:25",
                                         "departure":  "09:33:05"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "09:30:14",
                                                          "09:29:44"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "09:29:44",
                                         "departure":  "09:30:14"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "09:25:45",
                                                          "09:25:15"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "09:25:15",
                                         "departure":  "09:25:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "09:22:06",
                                                          "09:21:36"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "09:21:36",
                                         "departure":  "09:22:06"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "09:18:57",
                                                          "09:18:27"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "09:18:27",
                                         "departure":  "09:18:57"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "09:12:58",
                                                          "09:12:18"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "09:12:18",
                                         "departure":  "09:12:58"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "09:09:45",
                                                          "09:09:15"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "09:09:15",
                                         "departure":  "09:09:45"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "09:07:30"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "departure":  "09:07:30"
                                     }
                                 ],
                      "circulationId":  "C003",
                      "vehicleId":  "trainset-003",
                      "classification":  "revenue",
                      "movementType":  "passenger-service",
                      "postTripState":  "standby-xiangan-turnback-i",
                      "postTripStateAt":  "09:48:00"
                  },
                  {
                      "tripId":  "00406",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  1,
                      "sourceColumn":  10,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "10:09:59",
                                                          "10:09:09"
                                                      ],
                                         "sourceY":  [
                                                         133.528,
                                                         145.764
                                                     ],
                                         "arrival":  "10:09:09",
                                         "turnbackContextAfter":  "10:09:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "10:08:43"
                                                      ],
                                         "sourceY":  [
                                                         164.104
                                                     ],
                                         "pass":  "10:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "10:02:09",
                                                          "10:01:39"
                                                      ],
                                         "sourceY":  [
                                                         182.472,
                                                         194.708
                                                     ],
                                         "arrival":  "10:01:39",
                                         "departure":  "10:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "09:59:14",
                                                          "09:58:44"
                                                      ],
                                         "sourceY":  [
                                                         206.944,
                                                         219.208
                                                     ],
                                         "arrival":  "09:58:44",
                                         "departure":  "09:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "09:55:35",
                                                          "09:54:55"
                                                      ],
                                         "sourceY":  [
                                                         231.444,
                                                         243.68
                                                     ],
                                         "arrival":  "09:54:55",
                                         "departure":  "09:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "09:52:44",
                                                          "09:52:14"
                                                      ],
                                         "sourceY":  [
                                                         255.916,
                                                         268.152
                                                     ],
                                         "arrival":  "09:52:14",
                                         "departure":  "09:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "09:48:15",
                                                          "09:47:45"
                                                      ],
                                         "sourceY":  [
                                                         280.388,
                                                         292.624
                                                     ],
                                         "arrival":  "09:47:45",
                                         "departure":  "09:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "09:44:36",
                                                          "09:44:06"
                                                      ],
                                         "sourceY":  [
                                                         304.888,
                                                         317.124
                                                     ],
                                         "arrival":  "09:44:06",
                                         "departure":  "09:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "09:41:27",
                                                          "09:40:57"
                                                      ],
                                         "sourceY":  [
                                                         329.36,
                                                         341.596
                                                     ],
                                         "arrival":  "09:40:57",
                                         "departure":  "09:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "09:35:28",
                                                          "09:34:48"
                                                      ],
                                         "sourceY":  [
                                                         353.832,
                                                         366.068
                                                     ],
                                         "arrival":  "09:34:48",
                                         "departure":  "09:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "09:32:15",
                                                          "09:31:45"
                                                      ],
                                         "sourceY":  [
                                                         378.304,
                                                         390.568
                                                     ],
                                         "arrival":  "09:31:45",
                                         "departure":  "09:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "09:30:00"
                                                      ],
                                         "sourceY":  [
                                                         427.276
                                                     ],
                                         "departure":  "09:30:00"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00213",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  2,
                      "sourceColumn":  1,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "15:15:31",
                                                          "15:16:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "15:16:21",
                                         "turnbackContextBefore":  "15:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "15:16:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "15:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "15:23:18",
                                                          "15:23:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "15:23:18",
                                         "departure":  "15:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "15:26:13",
                                                          "15:26:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "15:26:13",
                                         "departure":  "15:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "15:29:59",
                                                          "15:30:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "15:29:59",
                                         "departure":  "15:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "15:32:46",
                                                          "15:33:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "15:32:46",
                                         "departure":  "15:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "15:37:15",
                                                          "15:37:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "15:37:15",
                                         "departure":  "15:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "15:40:53",
                                                          "15:41:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "15:40:53",
                                         "departure":  "15:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "15:44:03",
                                                          "15:44:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "15:44:03",
                                         "departure":  "15:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "15:50:03",
                                                          "15:50:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "15:50:03",
                                         "departure":  "15:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "15:53:19",
                                                          "15:53:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "15:53:19",
                                         "departure":  "15:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "15:55:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "15:55:50"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00413",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  2,
                      "sourceColumn":  2,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "14:45:31",
                                                          "14:46:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "14:46:21",
                                         "turnbackContextBefore":  "14:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "14:46:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "14:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "14:53:18",
                                                          "14:53:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "14:53:18",
                                         "departure":  "14:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "14:56:13",
                                                          "14:56:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "14:56:13",
                                         "departure":  "14:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "14:59:59",
                                                          "15:00:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "14:59:59",
                                         "departure":  "15:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "15:02:46",
                                                          "15:03:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "15:02:46",
                                         "departure":  "15:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "15:07:15",
                                                          "15:07:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "15:07:15",
                                         "departure":  "15:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "15:10:53",
                                                          "15:11:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "15:10:53",
                                         "departure":  "15:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "15:14:03",
                                                          "15:14:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "15:14:03",
                                         "departure":  "15:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "15:20:03",
                                                          "15:20:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "15:20:03",
                                         "departure":  "15:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "15:23:19",
                                                          "15:23:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "15:23:19",
                                         "departure":  "15:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "15:25:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "15:25:50"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00111",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  2,
                      "sourceColumn":  3,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "14:15:31",
                                                          "14:16:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "14:16:21",
                                         "turnbackContextBefore":  "14:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "14:16:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "14:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "14:23:18",
                                                          "14:23:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "14:23:18",
                                         "departure":  "14:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "14:26:13",
                                                          "14:26:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "14:26:13",
                                         "departure":  "14:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "14:29:59",
                                                          "14:30:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "14:29:59",
                                         "departure":  "14:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "14:32:46",
                                                          "14:33:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "14:32:46",
                                         "departure":  "14:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "14:37:15",
                                                          "14:37:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "14:37:15",
                                         "departure":  "14:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "14:40:53",
                                                          "14:41:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "14:40:53",
                                         "departure":  "14:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "14:44:03",
                                                          "14:44:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "14:44:03",
                                         "departure":  "14:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "14:50:03",
                                                          "14:50:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "14:50:03",
                                         "departure":  "14:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "14:53:19",
                                                          "14:53:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "14:53:19",
                                         "departure":  "14:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "14:55:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "14:55:50"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00211",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  2,
                      "sourceColumn":  4,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "13:45:31",
                                                          "13:46:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "13:46:21",
                                         "turnbackContextBefore":  "13:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "13:46:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "13:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "13:53:18",
                                                          "13:53:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "13:53:18",
                                         "departure":  "13:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "13:56:13",
                                                          "13:56:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "13:56:13",
                                         "departure":  "13:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "13:59:59",
                                                          "14:00:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "13:59:59",
                                         "departure":  "14:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "14:02:46",
                                                          "14:03:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "14:02:46",
                                         "departure":  "14:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "14:07:15",
                                                          "14:07:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "14:07:15",
                                         "departure":  "14:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "14:10:53",
                                                          "14:11:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "14:10:53",
                                         "departure":  "14:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "14:14:03",
                                                          "14:14:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "14:14:03",
                                         "departure":  "14:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "14:20:03",
                                                          "14:20:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "14:20:03",
                                         "departure":  "14:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "14:23:19",
                                                          "14:23:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "14:23:19",
                                         "departure":  "14:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "14:25:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "14:25:50"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00411",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  2,
                      "sourceColumn":  5,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "13:15:31",
                                                          "13:16:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "13:16:21",
                                         "turnbackContextBefore":  "13:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "13:16:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "13:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "13:23:18",
                                                          "13:23:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "13:23:18",
                                         "departure":  "13:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "13:26:13",
                                                          "13:26:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "13:26:13",
                                         "departure":  "13:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "13:29:59",
                                                          "13:30:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "13:29:59",
                                         "departure":  "13:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "13:32:46",
                                                          "13:33:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "13:32:46",
                                         "departure":  "13:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "13:37:15",
                                                          "13:37:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "13:37:15",
                                         "departure":  "13:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "13:40:53",
                                                          "13:41:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "13:40:53",
                                         "departure":  "13:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "13:44:03",
                                                          "13:44:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "13:44:03",
                                         "departure":  "13:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "13:50:03",
                                                          "13:50:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "13:50:03",
                                         "departure":  "13:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "13:53:19",
                                                          "13:53:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "13:53:19",
                                         "departure":  "13:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "13:55:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "13:55:50"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00109",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  2,
                      "sourceColumn":  6,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "12:45:31",
                                                          "12:46:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "12:46:21",
                                         "turnbackContextBefore":  "12:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "12:46:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "12:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "12:53:18",
                                                          "12:53:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "12:53:18",
                                         "departure":  "12:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "12:56:13",
                                                          "12:56:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "12:56:13",
                                         "departure":  "12:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "12:59:59",
                                                          "13:00:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "12:59:59",
                                         "departure":  "13:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "13:02:46",
                                                          "13:03:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "13:02:46",
                                         "departure":  "13:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "13:07:15",
                                                          "13:07:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "13:07:15",
                                         "departure":  "13:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "13:10:53",
                                                          "13:11:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "13:10:53",
                                         "departure":  "13:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "13:14:03",
                                                          "13:14:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "13:14:03",
                                         "departure":  "13:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "13:20:03",
                                                          "13:20:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "13:20:03",
                                         "departure":  "13:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "13:23:19",
                                                          "13:23:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "13:23:19",
                                         "departure":  "13:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "13:25:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "13:25:50"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00209",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  2,
                      "sourceColumn":  7,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "12:15:31",
                                                          "12:16:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "12:16:21",
                                         "turnbackContextBefore":  "12:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "12:16:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "12:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "12:23:18",
                                                          "12:23:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "12:23:18",
                                         "departure":  "12:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "12:26:13",
                                                          "12:26:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "12:26:13",
                                         "departure":  "12:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "12:29:59",
                                                          "12:30:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "12:29:59",
                                         "departure":  "12:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "12:32:46",
                                                          "12:33:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "12:32:46",
                                         "departure":  "12:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "12:37:15",
                                                          "12:37:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "12:37:15",
                                         "departure":  "12:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "12:40:53",
                                                          "12:41:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "12:40:53",
                                         "departure":  "12:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "12:44:03",
                                                          "12:44:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "12:44:03",
                                         "departure":  "12:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "12:50:03",
                                                          "12:50:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "12:50:03",
                                         "departure":  "12:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "12:53:19",
                                                          "12:53:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "12:53:19",
                                         "departure":  "12:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "12:55:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "12:55:50"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00409",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  2,
                      "sourceColumn":  8,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "11:45:31",
                                                          "11:46:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "11:46:21",
                                         "turnbackContextBefore":  "11:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "11:46:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "11:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "11:53:18",
                                                          "11:53:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "11:53:18",
                                         "departure":  "11:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "11:56:13",
                                                          "11:56:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "11:56:13",
                                         "departure":  "11:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "11:59:59",
                                                          "12:00:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "11:59:59",
                                         "departure":  "12:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "12:02:46",
                                                          "12:03:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "12:02:46",
                                         "departure":  "12:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "12:07:15",
                                                          "12:07:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "12:07:15",
                                         "departure":  "12:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "12:10:53",
                                                          "12:11:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "12:10:53",
                                         "departure":  "12:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "12:14:03",
                                                          "12:14:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "12:14:03",
                                         "departure":  "12:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "12:20:03",
                                                          "12:20:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "12:20:03",
                                         "departure":  "12:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "12:23:19",
                                                          "12:23:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "12:23:19",
                                         "departure":  "12:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "12:25:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "12:25:50"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00107",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  2,
                      "sourceColumn":  9,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "11:15:31",
                                                          "11:16:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "11:16:21",
                                         "turnbackContextBefore":  "11:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "11:16:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "11:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "11:23:18",
                                                          "11:23:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "11:23:18",
                                         "departure":  "11:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "11:26:13",
                                                          "11:26:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "11:26:13",
                                         "departure":  "11:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "11:29:59",
                                                          "11:30:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "11:29:59",
                                         "departure":  "11:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "11:32:46",
                                                          "11:33:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "11:32:46",
                                         "departure":  "11:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "11:37:15",
                                                          "11:37:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "11:37:15",
                                         "departure":  "11:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "11:40:53",
                                                          "11:41:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "11:40:53",
                                         "departure":  "11:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "11:44:03",
                                                          "11:44:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "11:44:03",
                                         "departure":  "11:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "11:50:03",
                                                          "11:50:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "11:50:03",
                                         "departure":  "11:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "11:53:19",
                                                          "11:53:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "11:53:19",
                                         "departure":  "11:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "11:55:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "11:55:50"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00207",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  2,
                      "sourceColumn":  10,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "10:45:31",
                                                          "10:46:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "10:46:21",
                                         "turnbackContextBefore":  "10:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "10:46:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "10:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "10:53:18",
                                                          "10:53:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "10:53:18",
                                         "departure":  "10:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "10:56:13",
                                                          "10:56:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "10:56:13",
                                         "departure":  "10:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "10:59:59",
                                                          "11:00:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "10:59:59",
                                         "departure":  "11:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "11:02:46",
                                                          "11:03:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "11:02:46",
                                         "departure":  "11:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "11:07:15",
                                                          "11:07:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "11:07:15",
                                         "departure":  "11:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "11:10:53",
                                                          "11:11:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "11:10:53",
                                         "departure":  "11:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "11:14:03",
                                                          "11:14:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "11:14:03",
                                         "departure":  "11:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "11:20:03",
                                                          "11:20:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "11:20:03",
                                         "departure":  "11:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "11:23:19",
                                                          "11:23:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "11:23:19",
                                         "departure":  "11:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "11:25:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "11:25:50"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00206",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  2,
                      "sourceColumn":  1,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "10:39:59",
                                                          "10:39:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "10:39:09",
                                         "turnbackContextAfter":  "10:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "10:38:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "10:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "10:32:09",
                                                          "10:31:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "10:31:39",
                                         "departure":  "10:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "10:29:14",
                                                          "10:28:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "10:28:44",
                                         "departure":  "10:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "10:25:35",
                                                          "10:24:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "10:24:55",
                                         "departure":  "10:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "10:22:44",
                                                          "10:22:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "10:22:14",
                                         "departure":  "10:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "10:18:15",
                                                          "10:17:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "10:17:45",
                                         "departure":  "10:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "10:14:36",
                                                          "10:14:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "10:14:06",
                                         "departure":  "10:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "10:11:27",
                                                          "10:10:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "10:10:57",
                                         "departure":  "10:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "10:05:28",
                                                          "10:04:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "10:04:48",
                                         "departure":  "10:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "10:02:15",
                                                          "10:01:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "10:01:45",
                                         "departure":  "10:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "10:00:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "10:00:00"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00106",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  2,
                      "sourceColumn":  2,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "11:09:59",
                                                          "11:09:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "11:09:09",
                                         "turnbackContextAfter":  "11:09:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "11:08:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "11:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "11:02:09",
                                                          "11:01:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "11:01:39",
                                         "departure":  "11:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "10:59:14",
                                                          "10:58:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "10:58:44",
                                         "departure":  "10:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "10:55:35",
                                                          "10:54:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "10:54:55",
                                         "departure":  "10:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "10:52:44",
                                                          "10:52:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "10:52:14",
                                         "departure":  "10:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "10:48:15",
                                                          "10:47:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "10:47:45",
                                         "departure":  "10:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "10:44:36",
                                                          "10:44:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "10:44:06",
                                         "departure":  "10:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "10:41:27",
                                                          "10:40:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "10:40:57",
                                         "departure":  "10:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "10:35:28",
                                                          "10:34:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "10:34:48",
                                         "departure":  "10:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "10:32:15",
                                                          "10:31:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "10:31:45",
                                         "departure":  "10:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "10:30:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "10:30:00"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00408",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  2,
                      "sourceColumn":  3,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "11:39:59",
                                                          "11:39:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "11:39:09",
                                         "turnbackContextAfter":  "11:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "11:38:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "11:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "11:32:09",
                                                          "11:31:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "11:31:39",
                                         "departure":  "11:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "11:29:14",
                                                          "11:28:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "11:28:44",
                                         "departure":  "11:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "11:25:35",
                                                          "11:24:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "11:24:55",
                                         "departure":  "11:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "11:22:44",
                                                          "11:22:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "11:22:14",
                                         "departure":  "11:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "11:18:15",
                                                          "11:17:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "11:17:45",
                                         "departure":  "11:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "11:14:36",
                                                          "11:14:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "11:14:06",
                                         "departure":  "11:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "11:11:27",
                                                          "11:10:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "11:10:57",
                                         "departure":  "11:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "11:05:28",
                                                          "11:04:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "11:04:48",
                                         "departure":  "11:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "11:02:15",
                                                          "11:01:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "11:01:45",
                                         "departure":  "11:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "11:00:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "11:00:00"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00208",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  2,
                      "sourceColumn":  4,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "12:09:59",
                                                          "12:09:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "12:09:09",
                                         "turnbackContextAfter":  "12:09:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "12:08:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "12:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "12:02:09",
                                                          "12:01:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "12:01:39",
                                         "departure":  "12:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "11:59:14",
                                                          "11:58:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "11:58:44",
                                         "departure":  "11:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "11:55:35",
                                                          "11:54:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "11:54:55",
                                         "departure":  "11:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "11:52:44",
                                                          "11:52:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "11:52:14",
                                         "departure":  "11:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "11:48:15",
                                                          "11:47:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "11:47:45",
                                         "departure":  "11:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "11:44:36",
                                                          "11:44:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "11:44:06",
                                         "departure":  "11:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "11:41:27",
                                                          "11:40:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "11:40:57",
                                         "departure":  "11:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "11:35:28",
                                                          "11:34:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "11:34:48",
                                         "departure":  "11:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "11:32:15",
                                                          "11:31:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "11:31:45",
                                         "departure":  "11:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "11:30:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "11:30:00"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00108",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  2,
                      "sourceColumn":  5,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "12:39:59",
                                                          "12:39:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "12:39:09",
                                         "turnbackContextAfter":  "12:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "12:38:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "12:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "12:32:09",
                                                          "12:31:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "12:31:39",
                                         "departure":  "12:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "12:29:14",
                                                          "12:28:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "12:28:44",
                                         "departure":  "12:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "12:25:35",
                                                          "12:24:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "12:24:55",
                                         "departure":  "12:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "12:22:44",
                                                          "12:22:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "12:22:14",
                                         "departure":  "12:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "12:18:15",
                                                          "12:17:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "12:17:45",
                                         "departure":  "12:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "12:14:36",
                                                          "12:14:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "12:14:06",
                                         "departure":  "12:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "12:11:27",
                                                          "12:10:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "12:10:57",
                                         "departure":  "12:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "12:05:28",
                                                          "12:04:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "12:04:48",
                                         "departure":  "12:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "12:02:15",
                                                          "12:01:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "12:01:45",
                                         "departure":  "12:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "12:00:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "12:00:00"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00410",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  2,
                      "sourceColumn":  6,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "13:09:59",
                                                          "13:09:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "13:09:09",
                                         "turnbackContextAfter":  "13:09:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "13:08:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "13:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "13:02:09",
                                                          "13:01:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "13:01:39",
                                         "departure":  "13:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "12:59:14",
                                                          "12:58:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "12:58:44",
                                         "departure":  "12:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "12:55:35",
                                                          "12:54:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "12:54:55",
                                         "departure":  "12:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "12:52:44",
                                                          "12:52:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "12:52:14",
                                         "departure":  "12:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "12:48:15",
                                                          "12:47:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "12:47:45",
                                         "departure":  "12:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "12:44:36",
                                                          "12:44:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "12:44:06",
                                         "departure":  "12:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "12:41:27",
                                                          "12:40:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "12:40:57",
                                         "departure":  "12:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "12:35:28",
                                                          "12:34:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "12:34:48",
                                         "departure":  "12:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "12:32:15",
                                                          "12:31:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "12:31:45",
                                         "departure":  "12:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "12:30:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "12:30:00"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00210",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  2,
                      "sourceColumn":  7,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "13:39:59",
                                                          "13:39:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "13:39:09",
                                         "turnbackContextAfter":  "13:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "13:38:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "13:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "13:32:09",
                                                          "13:31:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "13:31:39",
                                         "departure":  "13:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "13:29:14",
                                                          "13:28:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "13:28:44",
                                         "departure":  "13:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "13:25:35",
                                                          "13:24:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "13:24:55",
                                         "departure":  "13:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "13:22:44",
                                                          "13:22:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "13:22:14",
                                         "departure":  "13:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "13:18:15",
                                                          "13:17:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "13:17:45",
                                         "departure":  "13:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "13:14:36",
                                                          "13:14:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "13:14:06",
                                         "departure":  "13:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "13:11:27",
                                                          "13:10:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "13:10:57",
                                         "departure":  "13:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "13:05:28",
                                                          "13:04:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "13:04:48",
                                         "departure":  "13:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "13:02:15",
                                                          "13:01:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "13:01:45",
                                         "departure":  "13:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "13:00:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "13:00:00"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00110",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  2,
                      "sourceColumn":  8,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "14:09:59",
                                                          "14:09:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "14:09:09",
                                         "turnbackContextAfter":  "14:09:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "14:08:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "14:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "14:02:09",
                                                          "14:01:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "14:01:39",
                                         "departure":  "14:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "13:59:14",
                                                          "13:58:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "13:58:44",
                                         "departure":  "13:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "13:55:35",
                                                          "13:54:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "13:54:55",
                                         "departure":  "13:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "13:52:44",
                                                          "13:52:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "13:52:14",
                                         "departure":  "13:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "13:48:15",
                                                          "13:47:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "13:47:45",
                                         "departure":  "13:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "13:44:36",
                                                          "13:44:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "13:44:06",
                                         "departure":  "13:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "13:41:27",
                                                          "13:40:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "13:40:57",
                                         "departure":  "13:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "13:35:28",
                                                          "13:34:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "13:34:48",
                                         "departure":  "13:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "13:32:15",
                                                          "13:31:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "13:31:45",
                                         "departure":  "13:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "13:30:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "13:30:00"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00412",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  2,
                      "sourceColumn":  9,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "14:39:59",
                                                          "14:39:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "14:39:09",
                                         "turnbackContextAfter":  "14:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "14:38:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "14:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "14:32:09",
                                                          "14:31:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "14:31:39",
                                         "departure":  "14:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "14:29:14",
                                                          "14:28:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "14:28:44",
                                         "departure":  "14:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "14:25:35",
                                                          "14:24:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "14:24:55",
                                         "departure":  "14:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "14:22:44",
                                                          "14:22:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "14:22:14",
                                         "departure":  "14:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "14:18:15",
                                                          "14:17:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "14:17:45",
                                         "departure":  "14:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "14:14:36",
                                                          "14:14:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "14:14:06",
                                         "departure":  "14:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "14:11:27",
                                                          "14:10:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "14:10:57",
                                         "departure":  "14:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "14:05:28",
                                                          "14:04:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "14:04:48",
                                         "departure":  "14:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "14:02:15",
                                                          "14:01:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "14:01:45",
                                         "departure":  "14:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "14:00:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "14:00:00"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00212",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  2,
                      "sourceColumn":  10,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "15:09:59",
                                                          "15:09:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "15:09:09",
                                         "turnbackContextAfter":  "15:09:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "15:08:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "15:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "15:02:09",
                                                          "15:01:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "15:01:39",
                                         "departure":  "15:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "14:59:14",
                                                          "14:58:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "14:58:44",
                                         "departure":  "14:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "14:55:35",
                                                          "14:54:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "14:54:55",
                                         "departure":  "14:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "14:52:44",
                                                          "14:52:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "14:52:14",
                                         "departure":  "14:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "14:48:15",
                                                          "14:47:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "14:47:45",
                                         "departure":  "14:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "14:44:36",
                                                          "14:44:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "14:44:06",
                                         "departure":  "14:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "14:41:27",
                                                          "14:40:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "14:40:57",
                                         "departure":  "14:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "14:35:28",
                                                          "14:34:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "14:34:48",
                                         "departure":  "14:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "14:32:15",
                                                          "14:31:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "14:31:45",
                                         "departure":  "14:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "14:30:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "14:30:00"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00219",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  3,
                      "sourceColumn":  1,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "19:58:10",
                                                          "20:00:00"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "20:00:00",
                                         "turnbackContextBefore":  "19:58:10"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "20:00:27"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "20:00:27"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "20:06:57",
                                                          "20:07:27"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "20:06:57",
                                         "departure":  "20:07:27"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "20:09:52",
                                                          "20:10:22"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "20:09:52",
                                         "departure":  "20:10:22"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "20:13:38",
                                                          "20:14:18"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "20:13:38",
                                         "departure":  "20:14:18"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "20:16:25",
                                                          "20:16:55"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "20:16:25",
                                         "departure":  "20:16:55"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "20:20:54",
                                                          "20:21:24"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "20:20:54",
                                         "departure":  "20:21:24"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "20:24:32",
                                                          "20:25:02"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "20:24:32",
                                         "departure":  "20:25:02"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "20:27:42",
                                                          "20:28:12"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "20:27:42",
                                         "departure":  "20:28:12"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "20:33:42",
                                                          "20:34:22"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "20:33:42",
                                         "departure":  "20:34:22"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "20:36:58",
                                                          "20:37:38"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "20:36:58",
                                         "departure":  "20:37:38"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "20:39:39"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "20:39:39"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00501",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  3,
                      "sourceColumn":  2,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "19:37:20",
                                                          "19:38:10"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "19:38:10",
                                         "turnbackContextBefore":  "19:37:20"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "19:38:37"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "19:38:37"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "19:45:07",
                                                          "19:45:37"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "19:45:07",
                                         "departure":  "19:45:37"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "19:48:02",
                                                          "19:48:32"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "19:48:02",
                                         "departure":  "19:48:32"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "19:51:48",
                                                          "19:52:28"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "19:51:48",
                                         "departure":  "19:52:28"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "19:54:35",
                                                          "19:55:05"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "19:54:35",
                                         "departure":  "19:55:05"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "19:59:04",
                                                          "19:59:34"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "19:59:04",
                                         "departure":  "19:59:34"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "20:02:42",
                                                          "20:03:12"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "20:02:42",
                                         "departure":  "20:03:12"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "20:05:52",
                                                          "20:06:22"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "20:05:52",
                                         "departure":  "20:06:22"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "20:11:52",
                                                          "20:12:32"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "20:11:52",
                                         "departure":  "20:12:32"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "20:15:08",
                                                          "20:15:38"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "20:15:08",
                                         "departure":  "20:15:38"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "20:17:39"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "20:17:39"
                                     }
                                 ],
                      "circulationId":  "C003",
                      "vehicleId":  "trainset-003",
                      "classification":  "revenue",
                      "movementType":  "passenger-service",
                      "preTripState":  "standby-xiangan-turnback-i",
                      "preTripStateAt":  "19:36:00"
                  },
                  {
                      "tripId":  "00419",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  3,
                      "sourceColumn":  3,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "19:15:31",
                                                          "19:16:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "19:16:21",
                                         "turnbackContextBefore":  "19:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "19:16:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "19:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "19:23:18",
                                                          "19:23:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "19:23:18",
                                         "departure":  "19:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "19:26:13",
                                                          "19:26:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "19:26:13",
                                         "departure":  "19:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "19:29:59",
                                                          "19:30:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "19:29:59",
                                         "departure":  "19:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "19:32:46",
                                                          "19:33:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "19:32:46",
                                         "departure":  "19:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "19:37:15",
                                                          "19:37:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "19:37:15",
                                         "departure":  "19:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "19:40:53",
                                                          "19:41:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "19:40:53",
                                         "departure":  "19:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "19:44:03",
                                                          "19:44:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "19:44:03",
                                         "departure":  "19:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "19:50:03",
                                                          "19:50:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "19:50:03",
                                         "departure":  "19:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "19:53:19",
                                                          "19:53:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "19:53:19",
                                         "departure":  "19:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "19:55:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "19:55:50"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00117",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  3,
                      "sourceColumn":  4,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "18:45:31",
                                                          "18:46:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "18:46:21",
                                         "turnbackContextBefore":  "18:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "18:46:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "18:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "18:53:18",
                                                          "18:53:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "18:53:18",
                                         "departure":  "18:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "18:56:13",
                                                          "18:56:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "18:56:13",
                                         "departure":  "18:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "18:59:59",
                                                          "19:00:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "18:59:59",
                                         "departure":  "19:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "19:02:46",
                                                          "19:03:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "19:02:46",
                                         "departure":  "19:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "19:07:15",
                                                          "19:07:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "19:07:15",
                                         "departure":  "19:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "19:10:53",
                                                          "19:11:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "19:10:53",
                                         "departure":  "19:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "19:14:03",
                                                          "19:14:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "19:14:03",
                                         "departure":  "19:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "19:20:03",
                                                          "19:20:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "19:20:03",
                                         "departure":  "19:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "19:23:19",
                                                          "19:23:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "19:23:19",
                                         "departure":  "19:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "19:25:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "19:25:50"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00217",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  3,
                      "sourceColumn":  5,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "18:15:31",
                                                          "18:16:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "18:16:21",
                                         "turnbackContextBefore":  "18:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "18:16:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "18:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "18:23:18",
                                                          "18:23:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "18:23:18",
                                         "departure":  "18:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "18:26:13",
                                                          "18:26:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "18:26:13",
                                         "departure":  "18:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "18:29:59",
                                                          "18:30:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "18:29:59",
                                         "departure":  "18:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "18:32:46",
                                                          "18:33:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "18:32:46",
                                         "departure":  "18:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "18:37:15",
                                                          "18:37:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "18:37:15",
                                         "departure":  "18:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "18:40:53",
                                                          "18:41:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "18:40:53",
                                         "departure":  "18:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "18:44:03",
                                                          "18:44:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "18:44:03",
                                         "departure":  "18:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "18:50:03",
                                                          "18:50:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "18:50:03",
                                         "departure":  "18:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "18:53:19",
                                                          "18:53:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "18:53:19",
                                         "departure":  "18:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "18:55:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "18:55:50"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00417",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  3,
                      "sourceColumn":  6,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "17:45:31",
                                                          "17:46:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "17:46:21",
                                         "turnbackContextBefore":  "17:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "17:46:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "17:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "17:53:18",
                                                          "17:53:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "17:53:18",
                                         "departure":  "17:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "17:56:13",
                                                          "17:56:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "17:56:13",
                                         "departure":  "17:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "17:59:59",
                                                          "18:00:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "17:59:59",
                                         "departure":  "18:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "18:02:46",
                                                          "18:03:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "18:02:46",
                                         "departure":  "18:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "18:07:15",
                                                          "18:07:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "18:07:15",
                                         "departure":  "18:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "18:10:53",
                                                          "18:11:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "18:10:53",
                                         "departure":  "18:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "18:14:03",
                                                          "18:14:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "18:14:03",
                                         "departure":  "18:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "18:20:03",
                                                          "18:20:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "18:20:03",
                                         "departure":  "18:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "18:23:19",
                                                          "18:23:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "18:23:19",
                                         "departure":  "18:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "18:25:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "18:25:50"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00115",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  3,
                      "sourceColumn":  7,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "17:15:31",
                                                          "17:16:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "17:16:21",
                                         "turnbackContextBefore":  "17:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "17:16:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "17:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "17:23:18",
                                                          "17:23:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "17:23:18",
                                         "departure":  "17:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "17:26:13",
                                                          "17:26:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "17:26:13",
                                         "departure":  "17:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "17:29:59",
                                                          "17:30:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "17:29:59",
                                         "departure":  "17:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "17:32:46",
                                                          "17:33:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "17:32:46",
                                         "departure":  "17:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "17:37:15",
                                                          "17:37:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "17:37:15",
                                         "departure":  "17:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "17:40:53",
                                                          "17:41:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "17:40:53",
                                         "departure":  "17:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "17:44:03",
                                                          "17:44:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "17:44:03",
                                         "departure":  "17:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "17:50:03",
                                                          "17:50:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "17:50:03",
                                         "departure":  "17:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "17:53:19",
                                                          "17:53:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "17:53:19",
                                         "departure":  "17:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "17:55:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "17:55:50"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00215",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  3,
                      "sourceColumn":  8,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "16:45:31",
                                                          "16:46:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "16:46:21",
                                         "turnbackContextBefore":  "16:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "16:46:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "16:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "16:53:18",
                                                          "16:53:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "16:53:18",
                                         "departure":  "16:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "16:56:13",
                                                          "16:56:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "16:56:13",
                                         "departure":  "16:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "16:59:59",
                                                          "17:00:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "16:59:59",
                                         "departure":  "17:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "17:02:46",
                                                          "17:03:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "17:02:46",
                                         "departure":  "17:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "17:07:15",
                                                          "17:07:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "17:07:15",
                                         "departure":  "17:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "17:10:53",
                                                          "17:11:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "17:10:53",
                                         "departure":  "17:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "17:14:03",
                                                          "17:14:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "17:14:03",
                                         "departure":  "17:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "17:20:03",
                                                          "17:20:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "17:20:03",
                                         "departure":  "17:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "17:23:19",
                                                          "17:23:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "17:23:19",
                                         "departure":  "17:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "17:25:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "17:25:50"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00415",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  3,
                      "sourceColumn":  9,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "16:15:31",
                                                          "16:16:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "16:16:21",
                                         "turnbackContextBefore":  "16:15:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "16:16:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "16:16:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "16:23:18",
                                                          "16:23:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "16:23:18",
                                         "departure":  "16:23:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "16:26:13",
                                                          "16:26:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "16:26:13",
                                         "departure":  "16:26:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "16:29:59",
                                                          "16:30:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "16:29:59",
                                         "departure":  "16:30:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "16:32:46",
                                                          "16:33:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "16:32:46",
                                         "departure":  "16:33:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "16:37:15",
                                                          "16:37:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "16:37:15",
                                         "departure":  "16:37:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "16:40:53",
                                                          "16:41:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "16:40:53",
                                         "departure":  "16:41:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "16:44:03",
                                                          "16:44:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "16:44:03",
                                         "departure":  "16:44:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "16:50:03",
                                                          "16:50:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "16:50:03",
                                         "departure":  "16:50:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "16:53:19",
                                                          "16:53:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "16:53:19",
                                         "departure":  "16:53:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "16:55:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "16:55:50"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00113",
                      "direction":  "down",
                      "destinationCode":  "092",
                      "sourcePage":  3,
                      "sourceColumn":  10,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "15:45:31",
                                                          "15:46:21"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "departure":  "15:46:21",
                                         "turnbackContextBefore":  "15:45:31"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "15:46:48"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "15:46:48"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "15:53:18",
                                                          "15:53:48"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "15:53:18",
                                         "departure":  "15:53:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "15:56:13",
                                                          "15:56:43"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "15:56:13",
                                         "departure":  "15:56:43"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "15:59:59",
                                                          "16:00:39"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "15:59:59",
                                         "departure":  "16:00:39"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "16:02:46",
                                                          "16:03:16"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "16:02:46",
                                         "departure":  "16:03:16"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "16:07:15",
                                                          "16:07:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "16:07:15",
                                         "departure":  "16:07:45"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "16:10:53",
                                                          "16:11:23"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "16:10:53",
                                         "departure":  "16:11:23"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "16:14:03",
                                                          "16:14:33"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "16:14:03",
                                         "departure":  "16:14:33"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "16:20:03",
                                                          "16:20:43"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "16:20:03",
                                         "departure":  "16:20:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "16:23:19",
                                                          "16:23:49"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "16:23:19",
                                         "departure":  "16:23:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "16:25:50"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "arrival":  "16:25:50"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00112",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  3,
                      "sourceColumn":  1,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "15:39:59",
                                                          "15:39:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "15:39:09",
                                         "turnbackContextAfter":  "15:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "15:38:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "15:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "15:32:09",
                                                          "15:31:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "15:31:39",
                                         "departure":  "15:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "15:29:14",
                                                          "15:28:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "15:28:44",
                                         "departure":  "15:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "15:25:35",
                                                          "15:24:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "15:24:55",
                                         "departure":  "15:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "15:22:44",
                                                          "15:22:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "15:22:14",
                                         "departure":  "15:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "15:18:15",
                                                          "15:17:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "15:17:45",
                                         "departure":  "15:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "15:14:36",
                                                          "15:14:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "15:14:06",
                                         "departure":  "15:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "15:11:27",
                                                          "15:10:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "15:10:57",
                                         "departure":  "15:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "15:05:28",
                                                          "15:04:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "15:04:48",
                                         "departure":  "15:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "15:02:15",
                                                          "15:01:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "15:01:45",
                                         "departure":  "15:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "15:00:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "15:00:00"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00414",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  3,
                      "sourceColumn":  2,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "16:09:59",
                                                          "16:09:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "16:09:09",
                                         "turnbackContextAfter":  "16:09:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "16:08:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "16:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "16:02:09",
                                                          "16:01:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "16:01:39",
                                         "departure":  "16:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "15:59:14",
                                                          "15:58:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "15:58:44",
                                         "departure":  "15:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "15:55:35",
                                                          "15:54:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "15:54:55",
                                         "departure":  "15:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "15:52:44",
                                                          "15:52:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "15:52:14",
                                         "departure":  "15:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "15:48:15",
                                                          "15:47:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "15:47:45",
                                         "departure":  "15:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "15:44:36",
                                                          "15:44:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "15:44:06",
                                         "departure":  "15:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "15:41:27",
                                                          "15:40:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "15:40:57",
                                         "departure":  "15:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "15:35:28",
                                                          "15:34:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "15:34:48",
                                         "departure":  "15:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "15:32:15",
                                                          "15:31:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "15:31:45",
                                         "departure":  "15:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "15:30:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "15:30:00"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00214",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  3,
                      "sourceColumn":  3,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "16:39:59",
                                                          "16:39:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "16:39:09",
                                         "turnbackContextAfter":  "16:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "16:38:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "16:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "16:32:09",
                                                          "16:31:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "16:31:39",
                                         "departure":  "16:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "16:29:14",
                                                          "16:28:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "16:28:44",
                                         "departure":  "16:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "16:25:35",
                                                          "16:24:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "16:24:55",
                                         "departure":  "16:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "16:22:44",
                                                          "16:22:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "16:22:14",
                                         "departure":  "16:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "16:18:15",
                                                          "16:17:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "16:17:45",
                                         "departure":  "16:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "16:14:36",
                                                          "16:14:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "16:14:06",
                                         "departure":  "16:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "16:11:27",
                                                          "16:10:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "16:10:57",
                                         "departure":  "16:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "16:05:28",
                                                          "16:04:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "16:04:48",
                                         "departure":  "16:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "16:02:15",
                                                          "16:01:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "16:01:45",
                                         "departure":  "16:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "16:00:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "16:00:00"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00114",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  3,
                      "sourceColumn":  4,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "17:09:59",
                                                          "17:09:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "17:09:09",
                                         "turnbackContextAfter":  "17:09:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "17:08:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "17:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "17:02:09",
                                                          "17:01:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "17:01:39",
                                         "departure":  "17:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "16:59:14",
                                                          "16:58:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "16:58:44",
                                         "departure":  "16:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "16:55:35",
                                                          "16:54:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "16:54:55",
                                         "departure":  "16:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "16:52:44",
                                                          "16:52:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "16:52:14",
                                         "departure":  "16:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "16:48:15",
                                                          "16:47:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "16:47:45",
                                         "departure":  "16:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "16:44:36",
                                                          "16:44:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "16:44:06",
                                         "departure":  "16:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "16:41:27",
                                                          "16:40:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "16:40:57",
                                         "departure":  "16:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "16:35:28",
                                                          "16:34:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "16:34:48",
                                         "departure":  "16:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "16:32:15",
                                                          "16:31:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "16:31:45",
                                         "departure":  "16:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "16:30:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "16:30:00"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00416",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  3,
                      "sourceColumn":  5,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "17:39:59",
                                                          "17:39:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "17:39:09",
                                         "turnbackContextAfter":  "17:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "17:38:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "17:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "17:32:09",
                                                          "17:31:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "17:31:39",
                                         "departure":  "17:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "17:29:14",
                                                          "17:28:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "17:28:44",
                                         "departure":  "17:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "17:25:35",
                                                          "17:24:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "17:24:55",
                                         "departure":  "17:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "17:22:44",
                                                          "17:22:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "17:22:14",
                                         "departure":  "17:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "17:18:15",
                                                          "17:17:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "17:17:45",
                                         "departure":  "17:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "17:14:36",
                                                          "17:14:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "17:14:06",
                                         "departure":  "17:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "17:11:27",
                                                          "17:10:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "17:10:57",
                                         "departure":  "17:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "17:05:28",
                                                          "17:04:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "17:04:48",
                                         "departure":  "17:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "17:02:15",
                                                          "17:01:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "17:01:45",
                                         "departure":  "17:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "17:00:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "17:00:00"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00216",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  3,
                      "sourceColumn":  6,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "18:09:59",
                                                          "18:09:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "18:09:09",
                                         "turnbackContextAfter":  "18:09:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "18:08:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "18:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "18:02:09",
                                                          "18:01:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "18:01:39",
                                         "departure":  "18:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "17:59:14",
                                                          "17:58:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "17:58:44",
                                         "departure":  "17:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "17:55:35",
                                                          "17:54:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "17:54:55",
                                         "departure":  "17:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "17:52:44",
                                                          "17:52:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "17:52:14",
                                         "departure":  "17:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "17:48:15",
                                                          "17:47:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "17:47:45",
                                         "departure":  "17:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "17:44:36",
                                                          "17:44:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "17:44:06",
                                         "departure":  "17:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "17:41:27",
                                                          "17:40:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "17:40:57",
                                         "departure":  "17:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "17:35:28",
                                                          "17:34:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "17:34:48",
                                         "departure":  "17:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "17:32:15",
                                                          "17:31:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "17:31:45",
                                         "departure":  "17:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "17:30:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "17:30:00"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00116",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  3,
                      "sourceColumn":  7,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "18:39:59",
                                                          "18:39:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "18:39:09",
                                         "turnbackContextAfter":  "18:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "18:38:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "18:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "18:32:09",
                                                          "18:31:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "18:31:39",
                                         "departure":  "18:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "18:29:14",
                                                          "18:28:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "18:28:44",
                                         "departure":  "18:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "18:25:35",
                                                          "18:24:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "18:24:55",
                                         "departure":  "18:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "18:22:44",
                                                          "18:22:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "18:22:14",
                                         "departure":  "18:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "18:18:15",
                                                          "18:17:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "18:17:45",
                                         "departure":  "18:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "18:14:36",
                                                          "18:14:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "18:14:06",
                                         "departure":  "18:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "18:11:27",
                                                          "18:10:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "18:10:57",
                                         "departure":  "18:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "18:05:28",
                                                          "18:04:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "18:04:48",
                                         "departure":  "18:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "18:02:15",
                                                          "18:01:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "18:01:45",
                                         "departure":  "18:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "18:00:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "18:00:00"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00418",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  3,
                      "sourceColumn":  8,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "19:09:59",
                                                          "19:09:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "19:09:09",
                                         "turnbackContextAfter":  "19:09:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "19:08:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "19:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "19:02:09",
                                                          "19:01:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "19:01:39",
                                         "departure":  "19:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "18:59:14",
                                                          "18:58:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "18:58:44",
                                         "departure":  "18:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "18:55:35",
                                                          "18:54:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "18:54:55",
                                         "departure":  "18:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "18:52:44",
                                                          "18:52:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "18:52:14",
                                         "departure":  "18:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "18:48:15",
                                                          "18:47:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "18:47:45",
                                         "departure":  "18:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "18:44:36",
                                                          "18:44:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "18:44:06",
                                         "departure":  "18:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "18:41:27",
                                                          "18:40:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "18:40:57",
                                         "departure":  "18:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "18:35:28",
                                                          "18:34:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "18:34:48",
                                         "departure":  "18:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "18:32:15",
                                                          "18:31:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "18:31:45",
                                         "departure":  "18:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "18:30:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "18:30:00"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00218",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  3,
                      "sourceColumn":  9,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "19:39:59",
                                                          "19:39:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "19:39:09",
                                         "turnbackContextAfter":  "19:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "19:38:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "19:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "19:32:09",
                                                          "19:31:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "19:31:39",
                                         "departure":  "19:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "19:29:14",
                                                          "19:28:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "19:28:44",
                                         "departure":  "19:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "19:25:35",
                                                          "19:24:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "19:24:55",
                                         "departure":  "19:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "19:22:44",
                                                          "19:22:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "19:22:14",
                                         "departure":  "19:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "19:18:15",
                                                          "19:17:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "19:17:45",
                                         "departure":  "19:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "19:14:36",
                                                          "19:14:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "19:14:06",
                                         "departure":  "19:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "19:11:27",
                                                          "19:10:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "19:10:57",
                                         "departure":  "19:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "19:05:28",
                                                          "19:04:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "19:04:48",
                                         "departure":  "19:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "19:02:15",
                                                          "19:01:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "19:01:45",
                                         "departure":  "19:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "19:00:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "19:00:00"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00118",
                      "direction":  "up",
                      "destinationCode":  "204",
                      "sourcePage":  3,
                      "sourceColumn":  10,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "20:10:39",
                                                          "20:09:09"
                                                      ],
                                         "sourceY":  [
                                                         135.26,
                                                         147.496
                                                     ],
                                         "arrival":  "20:09:09",
                                         "turnbackContextAfter":  "20:10:39"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "20:08:43"
                                                      ],
                                         "sourceY":  [
                                                         165.864
                                                     ],
                                         "pass":  "20:08:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "20:02:09",
                                                          "20:01:39"
                                                      ],
                                         "sourceY":  [
                                                         184.204,
                                                         196.468
                                                     ],
                                         "arrival":  "20:01:39",
                                         "departure":  "20:02:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "19:59:14",
                                                          "19:58:44"
                                                      ],
                                         "sourceY":  [
                                                         208.704,
                                                         220.94
                                                     ],
                                         "arrival":  "19:58:44",
                                         "departure":  "19:59:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "19:55:35",
                                                          "19:54:55"
                                                      ],
                                         "sourceY":  [
                                                         233.176,
                                                         245.412
                                                     ],
                                         "arrival":  "19:54:55",
                                         "departure":  "19:55:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "19:52:44",
                                                          "19:52:14"
                                                      ],
                                         "sourceY":  [
                                                         257.648,
                                                         269.884
                                                     ],
                                         "arrival":  "19:52:14",
                                         "departure":  "19:52:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "19:48:15",
                                                          "19:47:45"
                                                      ],
                                         "sourceY":  [
                                                         282.148,
                                                         294.384
                                                     ],
                                         "arrival":  "19:47:45",
                                         "departure":  "19:48:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "19:44:36",
                                                          "19:44:06"
                                                      ],
                                         "sourceY":  [
                                                         306.62,
                                                         318.856
                                                     ],
                                         "arrival":  "19:44:06",
                                         "departure":  "19:44:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "19:41:27",
                                                          "19:40:57"
                                                      ],
                                         "sourceY":  [
                                                         331.092,
                                                         343.328
                                                     ],
                                         "arrival":  "19:40:57",
                                         "departure":  "19:41:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "19:35:28",
                                                          "19:34:48"
                                                      ],
                                         "sourceY":  [
                                                         355.564,
                                                         367.828
                                                     ],
                                         "arrival":  "19:34:48",
                                         "departure":  "19:35:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "19:32:15",
                                                          "19:31:45"
                                                      ],
                                         "sourceY":  [
                                                         380.064,
                                                         392.3
                                                     ],
                                         "arrival":  "19:31:45",
                                         "departure":  "19:32:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "19:30:00"
                                                      ],
                                         "sourceY":  [
                                                         429.008
                                                     ],
                                         "departure":  "19:30:00"
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "revenue",
                      "movementType":  "passenger-service"
                  },
                  {
                      "tripId":  "00221",
                      "direction":  "down",
                      "destinationCode":  "106",
                      "sourcePage":  4,
                      "sourceColumn":  8,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "20:46:49"
                                                      ],
                                         "sourceY":  [
                                                         410.66
                                                     ],
                                         "pass":  "20:46:49"
                                     },
                                     {
                                         "locationId":  "houxi-depot",
                                         "rawTimes":  [
                                                          "20:47:49"
                                                      ],
                                         "sourceY":  [
                                                         422.896
                                                     ],
                                         "boundaryTime":  "20:47:49",
                                         "markers":  [
                                                         "▼G1010"
                                                     ]
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "non-revenue",
                      "movementType":  "depot-inbound"
                  },
                  {
                      "tripId":  "00503",
                      "direction":  "down",
                      "destinationCode":  "105",
                      "sourcePage":  4,
                      "sourceColumn":  9,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "20:25:09"
                                                      ],
                                         "sourceY":  [
                                                         410.66
                                                     ],
                                         "pass":  "20:25:09"
                                     },
                                     {
                                         "locationId":  "houxi-depot",
                                         "rawTimes":  [
                                                          "20:26:09"
                                                      ],
                                         "sourceY":  [
                                                         422.896
                                                     ],
                                         "boundaryTime":  "20:26:09",
                                         "markers":  [
                                                         "▼G1011"
                                                     ]
                                     }
                                 ],
                      "circulationId":  "C003",
                      "vehicleId":  "trainset-003",
                      "classification":  "non-revenue",
                      "movementType":  "depot-inbound"
                  },
                  {
                      "tripId":  "00119",
                      "direction":  "down",
                      "destinationCode":  "105",
                      "sourcePage":  4,
                      "sourceColumn":  10,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "20:15:30"
                                                      ],
                                         "sourceY":  [
                                                         159.724
                                                     ],
                                         "departure":  "20:15:30"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "20:15:55"
                                                      ],
                                         "sourceY":  [
                                                         184.224
                                                     ],
                                         "pass":  "20:15:55"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "20:21:48"
                                                      ],
                                         "sourceY":  [
                                                         208.696
                                                     ],
                                         "pass":  "20:21:48"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "20:23:59"
                                                      ],
                                         "sourceY":  [
                                                         233.168
                                                     ],
                                         "pass":  "20:23:59"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "20:26:56"
                                                      ],
                                         "sourceY":  [
                                                         257.668
                                                     ],
                                         "pass":  "20:26:56"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "20:28:51"
                                                      ],
                                         "sourceY":  [
                                                         282.14
                                                     ],
                                         "pass":  "20:28:51"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "20:32:28"
                                                      ],
                                         "sourceY":  [
                                                         306.612
                                                     ],
                                         "pass":  "20:32:28"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "20:35:19"
                                                      ],
                                         "sourceY":  [
                                                         331.084
                                                     ],
                                         "pass":  "20:35:19"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "20:37:44"
                                                      ],
                                         "sourceY":  [
                                                         355.584
                                                     ],
                                         "pass":  "20:37:44"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "20:42:43"
                                                      ],
                                         "sourceY":  [
                                                         380.056
                                                     ],
                                         "pass":  "20:42:43"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "20:45:05"
                                                      ],
                                         "sourceY":  [
                                                         404.528
                                                     ],
                                         "arrival":  "20:45:05"
                                     },
                                     {
                                         "locationId":  "houxi-depot",
                                         "rawTimes":  [
                                                          "20:46:05"
                                                      ],
                                         "sourceY":  [
                                                         422.896
                                                     ],
                                         "boundaryTime":  "20:46:05",
                                         "markers":  [
                                                         "▼G1011"
                                                     ]
                                     }
                                 ],
                      "circulationId":  "C001",
                      "vehicleId":  "trainset-001",
                      "classification":  "non-revenue",
                      "movementType":  "depot-inbound"
                  },
                  {
                      "tripId":  "00420",
                      "direction":  "up",
                      "destinationCode":  "203",
                      "sourcePage":  4,
                      "sourceColumn":  1,
                      "classificationHint":  "full-line-within-public-window",
                      "events":  [
                                     {
                                         "locationId":  "xiangan-airport",
                                         "rawTimes":  [
                                                          "20:39:59",
                                                          "20:39:09"
                                                      ],
                                         "sourceY":  [
                                                         153.62,
                                                         165.856
                                                     ],
                                         "arrival":  "20:39:09",
                                         "turnbackContextAfter":  "20:39:59"
                                     },
                                     {
                                         "locationId":  "airport-west-reserved",
                                         "rawTimes":  [
                                                          "20:38:43"
                                                      ],
                                         "sourceY":  [
                                                         184.224
                                                     ],
                                         "pass":  "20:38:43"
                                     },
                                     {
                                         "locationId":  "dongting",
                                         "rawTimes":  [
                                                          "20:32:09",
                                                          "20:31:39"
                                                      ],
                                         "sourceY":  [
                                                         202.564,
                                                         214.828
                                                     ],
                                         "arrival":  "20:31:39",
                                         "departure":  "20:32:09"
                                     },
                                     {
                                         "locationId":  "qianwu",
                                         "rawTimes":  [
                                                          "20:29:14",
                                                          "20:28:44"
                                                      ],
                                         "sourceY":  [
                                                         227.064,
                                                         239.3
                                                     ],
                                         "arrival":  "20:28:44",
                                         "departure":  "20:29:14"
                                     },
                                     {
                                         "locationId":  "hongkeng",
                                         "rawTimes":  [
                                                          "20:25:35",
                                                          "20:24:55"
                                                      ],
                                         "sourceY":  [
                                                         251.536,
                                                         263.772
                                                     ],
                                         "arrival":  "20:24:55",
                                         "departure":  "20:25:35"
                                     },
                                     {
                                         "locationId":  "xiyan",
                                         "rawTimes":  [
                                                          "20:22:44",
                                                          "20:22:14"
                                                      ],
                                         "sourceY":  [
                                                         276.008,
                                                         288.244
                                                     ],
                                         "arrival":  "20:22:14",
                                         "departure":  "20:22:44"
                                     },
                                     {
                                         "locationId":  "chengchang",
                                         "rawTimes":  [
                                                          "20:18:15",
                                                          "20:17:45"
                                                      ],
                                         "sourceY":  [
                                                         300.508,
                                                         312.744
                                                     ],
                                         "arrival":  "20:17:45",
                                         "departure":  "20:18:15"
                                     },
                                     {
                                         "locationId":  "bingzhou",
                                         "rawTimes":  [
                                                          "20:14:36",
                                                          "20:14:06"
                                                      ],
                                         "sourceY":  [
                                                         324.98,
                                                         337.216
                                                     ],
                                         "arrival":  "20:14:06",
                                         "departure":  "20:14:36"
                                     },
                                     {
                                         "locationId":  "guanxun",
                                         "rawTimes":  [
                                                          "20:11:27",
                                                          "20:10:57"
                                                      ],
                                         "sourceY":  [
                                                         349.452,
                                                         361.688
                                                     ],
                                         "arrival":  "20:10:57",
                                         "departure":  "20:11:27"
                                     },
                                     {
                                         "locationId":  "xiamen-north",
                                         "rawTimes":  [
                                                          "20:05:28",
                                                          "20:04:48"
                                                      ],
                                         "sourceY":  [
                                                         373.924,
                                                         386.188
                                                     ],
                                         "arrival":  "20:04:48",
                                         "departure":  "20:05:28"
                                     },
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "20:02:15",
                                                          "20:01:45"
                                                      ],
                                         "sourceY":  [
                                                         398.424,
                                                         410.66
                                                     ],
                                         "arrival":  "20:01:45",
                                         "departure":  "20:02:15"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "20:00:00"
                                                      ],
                                         "sourceY":  [
                                                         447.368
                                                     ],
                                         "departure":  "20:00:00"
                                     }
                                 ],
                      "circulationId":  "C004",
                      "vehicleId":  "trainset-004",
                      "classification":  "revenue",
                      "movementType":  "passenger-service",
                      "postTripState":  "stabled-xiangan-turnback-i",
                      "postTripStateAt":  "20:40:00"
                  },
                  {
                      "tripId":  "00502",
                      "direction":  "up",
                      "destinationCode":  "102",
                      "sourcePage":  4,
                      "sourceColumn":  2,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "20:22:59"
                                                      ],
                                         "sourceY":  [
                                                         410.66
                                                     ],
                                         "arrival":  "20:22:59"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "20:21:14"
                                                      ],
                                         "sourceY":  [
                                                         447.368
                                                     ],
                                         "departure":  "20:21:14"
                                     }
                                 ],
                      "circulationId":  "C003",
                      "vehicleId":  "trainset-003",
                      "classification":  "non-revenue",
                      "movementType":  "non-revenue-transition"
                  },
                  {
                      "tripId":  "00220",
                      "direction":  "up",
                      "destinationCode":  "102",
                      "sourcePage":  4,
                      "sourceColumn":  3,
                      "classificationHint":  "partial-or-depot",
                      "events":  [
                                     {
                                         "locationId":  "houxi",
                                         "rawTimes":  [
                                                          "20:44:49"
                                                      ],
                                         "sourceY":  [
                                                         410.66
                                                     ],
                                         "arrival":  "20:44:49"
                                     },
                                     {
                                         "locationId":  "jimei-software-park-north",
                                         "rawTimes":  [
                                                          "20:43:04"
                                                      ],
                                         "sourceY":  [
                                                         447.368
                                                     ],
                                         "departure":  "20:43:04"
                                     }
                                 ],
                      "circulationId":  "C002",
                      "vehicleId":  "trainset-002",
                      "classification":  "non-revenue",
                      "movementType":  "non-revenue-transition"
                  }
              ],
    "schemaVersion":  "1.3.0",
    "circulations":  [
                         {
                             "circulationId":  "C001",
                             "vehicleId":  "trainset-001",
                             "tripIds":  [
                                             "00101",
                                             "00102",
                                             "00103",
                                             "00104",
                                             "00105",
                                             "00106",
                                             "00107",
                                             "00108",
                                             "00109",
                                             "00110",
                                             "00111",
                                             "00112",
                                             "00113",
                                             "00114",
                                             "00115",
                                             "00116",
                                             "00117",
                                             "00118",
                                             "00119"
                                         ],
                             "startsAt":  {
                                              "locationId":  "xiangan-airport",
                                              "time":  "06:51:09"
                                          },
                             "endsAt":  {
                                            "locationId":  "houxi-depot",
                                            "time":  "20:46:05"
                                        },
                             "connections":  [
                                                 {
                                                     "fromTripId":  "00101",
                                                     "toTripId":  "00102",
                                                     "locationId":  "hongkeng",
                                                     "fromTime":  "07:15:06",
                                                     "toTime":  "07:18:31",
                                                     "layoverSeconds":  205,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00102",
                                                     "toTripId":  "00103",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "07:42:28",
                                                     "toTime":  "08:00:00",
                                                     "layoverSeconds":  1052,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00103",
                                                     "toTripId":  "00104",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "08:40:47",
                                                     "toTime":  "08:45:00",
                                                     "layoverSeconds":  253,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00104",
                                                     "toTripId":  "00105",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "09:24:09",
                                                     "toTime":  "09:46:21",
                                                     "layoverSeconds":  1332,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00105",
                                                     "toTripId":  "00106",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "10:25:50",
                                                     "toTime":  "10:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00106",
                                                     "toTripId":  "00107",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "11:09:09",
                                                     "toTime":  "11:16:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00107",
                                                     "toTripId":  "00108",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "11:55:50",
                                                     "toTime":  "12:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00108",
                                                     "toTripId":  "00109",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "12:39:09",
                                                     "toTime":  "12:46:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00109",
                                                     "toTripId":  "00110",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "13:25:50",
                                                     "toTime":  "13:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00110",
                                                     "toTripId":  "00111",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "14:09:09",
                                                     "toTime":  "14:16:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00111",
                                                     "toTripId":  "00112",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "14:55:50",
                                                     "toTime":  "15:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00112",
                                                     "toTripId":  "00113",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "15:39:09",
                                                     "toTime":  "15:46:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00113",
                                                     "toTripId":  "00114",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "16:25:50",
                                                     "toTime":  "16:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00114",
                                                     "toTripId":  "00115",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "17:09:09",
                                                     "toTime":  "17:16:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00115",
                                                     "toTripId":  "00116",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "17:55:50",
                                                     "toTime":  "18:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00116",
                                                     "toTripId":  "00117",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "18:39:09",
                                                     "toTime":  "18:46:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00117",
                                                     "toTripId":  "00118",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "19:25:50",
                                                     "toTime":  "19:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00118",
                                                     "toTripId":  "00119",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "20:09:09",
                                                     "toTime":  "20:15:30",
                                                     "layoverSeconds":  381,
                                                     "connectionType":  "turnback"
                                                 }
                                             ]
                         },
                         {
                             "circulationId":  "C002",
                             "vehicleId":  "trainset-002",
                             "tripIds":  [
                                             "00202",
                                             "00203",
                                             "00204",
                                             "00205",
                                             "00206",
                                             "00207",
                                             "00208",
                                             "00209",
                                             "00210",
                                             "00211",
                                             "00212",
                                             "00213",
                                             "00214",
                                             "00215",
                                             "00216",
                                             "00217",
                                             "00218",
                                             "00219",
                                             "00220",
                                             "00221"
                                         ],
                             "startsAt":  {
                                              "locationId":  "houxi-depot",
                                              "time":  "07:00:00"
                                          },
                             "endsAt":  {
                                            "locationId":  "houxi-depot",
                                            "time":  "20:47:49"
                                        },
                             "connections":  [
                                                 {
                                                     "fromTripId":  "00202",
                                                     "toTripId":  "00203",
                                                     "locationId":  "hongkeng",
                                                     "fromTime":  "07:39:45",
                                                     "toTime":  "07:48:54",
                                                     "layoverSeconds":  549,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00203",
                                                     "toTripId":  "00204",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "08:18:05",
                                                     "toTime":  "08:22:30",
                                                     "layoverSeconds":  265,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00204",
                                                     "toTripId":  "00205",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "09:01:39",
                                                     "toTime":  "09:16:21",
                                                     "layoverSeconds":  882,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00205",
                                                     "toTripId":  "00206",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "09:55:50",
                                                     "toTime":  "10:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00206",
                                                     "toTripId":  "00207",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "10:39:09",
                                                     "toTime":  "10:46:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00207",
                                                     "toTripId":  "00208",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "11:25:50",
                                                     "toTime":  "11:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00208",
                                                     "toTripId":  "00209",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "12:09:09",
                                                     "toTime":  "12:16:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00209",
                                                     "toTripId":  "00210",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "12:55:50",
                                                     "toTime":  "13:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00210",
                                                     "toTripId":  "00211",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "13:39:09",
                                                     "toTime":  "13:46:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00211",
                                                     "toTripId":  "00212",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "14:25:50",
                                                     "toTime":  "14:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00212",
                                                     "toTripId":  "00213",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "15:09:09",
                                                     "toTime":  "15:16:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00213",
                                                     "toTripId":  "00214",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "15:55:50",
                                                     "toTime":  "16:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00214",
                                                     "toTripId":  "00215",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "16:39:09",
                                                     "toTime":  "16:46:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00215",
                                                     "toTripId":  "00216",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "17:25:50",
                                                     "toTime":  "17:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00216",
                                                     "toTripId":  "00217",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "18:09:09",
                                                     "toTime":  "18:16:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00217",
                                                     "toTripId":  "00218",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "18:55:50",
                                                     "toTime":  "19:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00218",
                                                     "toTripId":  "00219",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "19:39:09",
                                                     "toTime":  "20:00:00",
                                                     "layoverSeconds":  1251,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00219",
                                                     "toTripId":  "00220",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "20:39:39",
                                                     "toTime":  "20:43:04",
                                                     "layoverSeconds":  205,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00220",
                                                     "toTripId":  "00221",
                                                     "locationId":  "houxi",
                                                     "fromTime":  "20:44:49",
                                                     "toTime":  "20:46:49",
                                                     "layoverSeconds":  120,
                                                     "connectionType":  "operational-reversal"
                                                 }
                                             ]
                         },
                         {
                             "circulationId":  "C003",
                             "vehicleId":  "trainset-003",
                             "tripIds":  [
                                             "00302",
                                             "00303",
                                             "00304",
                                             "00305",
                                             "00306",
                                             "00501",
                                             "00502",
                                             "00503"
                                         ],
                             "startsAt":  {
                                              "locationId":  "houxi-depot",
                                              "time":  "07:05:00"
                                          },
                             "endsAt":  {
                                            "locationId":  "houxi-depot",
                                            "time":  "20:26:09"
                                        },
                             "connections":  [
                                                 {
                                                     "fromTripId":  "00302",
                                                     "toTripId":  "00303",
                                                     "locationId":  "houxi",
                                                     "fromTime":  "07:06:00",
                                                     "toTime":  "07:08:29",
                                                     "layoverSeconds":  149,
                                                     "connectionType":  "operational-reversal"
                                                 },
                                                 {
                                                     "fromTripId":  "00303",
                                                     "toTripId":  "00304",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "07:10:57",
                                                     "toTime":  "07:13:54",
                                                     "layoverSeconds":  177,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00304",
                                                     "toTripId":  "00305",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "08:08:41",
                                                     "toTime":  "08:23:10",
                                                     "layoverSeconds":  869,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00305",
                                                     "toTripId":  "00306",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "09:02:39",
                                                     "toTime":  "09:07:30",
                                                     "layoverSeconds":  291,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00306",
                                                     "toTripId":  "00501",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "09:46:39",
                                                     "toTime":  "19:38:10",
                                                     "layoverSeconds":  35491,
                                                     "connectionType":  "standby"
                                                 },
                                                 {
                                                     "fromTripId":  "00501",
                                                     "toTripId":  "00502",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "20:17:39",
                                                     "toTime":  "20:21:14",
                                                     "layoverSeconds":  215,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00502",
                                                     "toTripId":  "00503",
                                                     "locationId":  "houxi",
                                                     "fromTime":  "20:22:59",
                                                     "toTime":  "20:25:09",
                                                     "layoverSeconds":  130,
                                                     "connectionType":  "operational-reversal"
                                                 }
                                             ]
                         },
                         {
                             "circulationId":  "C004",
                             "vehicleId":  "trainset-004",
                             "tripIds":  [
                                             "00402",
                                             "00403",
                                             "00404",
                                             "00405",
                                             "00406",
                                             "00407",
                                             "00408",
                                             "00409",
                                             "00410",
                                             "00411",
                                             "00412",
                                             "00413",
                                             "00414",
                                             "00415",
                                             "00416",
                                             "00417",
                                             "00418",
                                             "00419",
                                             "00420"
                                         ],
                             "startsAt":  {
                                              "locationId":  "houxi-depot",
                                              "time":  "07:47:00"
                                          },
                             "endsAt":  {
                                            "locationId":  "xiangan-airport",
                                            "time":  "20:39:09"
                                        },
                             "connections":  [
                                                 {
                                                     "fromTripId":  "00402",
                                                     "toTripId":  "00403",
                                                     "locationId":  "houxi",
                                                     "fromTime":  "07:51:00",
                                                     "toTime":  "07:53:59",
                                                     "layoverSeconds":  179,
                                                     "connectionType":  "operational-reversal"
                                                 },
                                                 {
                                                     "fromTripId":  "00403",
                                                     "toTripId":  "00404",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "07:56:00",
                                                     "toTime":  "08:00:00",
                                                     "layoverSeconds":  240,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00404",
                                                     "toTripId":  "00405",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "08:39:09",
                                                     "toTime":  "08:46:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00405",
                                                     "toTripId":  "00406",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "09:25:50",
                                                     "toTime":  "09:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00406",
                                                     "toTripId":  "00407",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "10:09:09",
                                                     "toTime":  "10:16:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00407",
                                                     "toTripId":  "00408",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "10:55:50",
                                                     "toTime":  "11:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00408",
                                                     "toTripId":  "00409",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "11:39:09",
                                                     "toTime":  "11:46:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00409",
                                                     "toTripId":  "00410",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "12:25:50",
                                                     "toTime":  "12:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00410",
                                                     "toTripId":  "00411",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "13:09:09",
                                                     "toTime":  "13:16:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00411",
                                                     "toTripId":  "00412",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "13:55:50",
                                                     "toTime":  "14:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00412",
                                                     "toTripId":  "00413",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "14:39:09",
                                                     "toTime":  "14:46:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00413",
                                                     "toTripId":  "00414",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "15:25:50",
                                                     "toTime":  "15:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00414",
                                                     "toTripId":  "00415",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "16:09:09",
                                                     "toTime":  "16:16:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00415",
                                                     "toTripId":  "00416",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "16:55:50",
                                                     "toTime":  "17:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00416",
                                                     "toTripId":  "00417",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "17:39:09",
                                                     "toTime":  "17:46:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00417",
                                                     "toTripId":  "00418",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "18:25:50",
                                                     "toTime":  "18:30:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00418",
                                                     "toTripId":  "00419",
                                                     "locationId":  "xiangan-airport",
                                                     "fromTime":  "19:09:09",
                                                     "toTime":  "19:16:21",
                                                     "layoverSeconds":  432,
                                                     "connectionType":  "turnback"
                                                 },
                                                 {
                                                     "fromTripId":  "00419",
                                                     "toTripId":  "00420",
                                                     "locationId":  "jimei-software-park-north",
                                                     "fromTime":  "19:55:50",
                                                     "toTime":  "20:00:00",
                                                     "layoverSeconds":  250,
                                                     "connectionType":  "turnback"
                                                 }
                                             ]
                         }
                     ],
    "standbyAssignments":  [
                               {
                                   "assignmentId":  "houxi-turnback-ii-reserve",
                                   "vehicleId":  "reserve-houxi-ii",
                                   "locationId":  "houxi",
                                   "operational":  false,
                                   "startTime":  "08:05:00",
                                   "endTime":  "20:05:00",
                                   "notes":  "Unnumbered reserve train; outbound via Houxi depot exit track and returns to depot at 20:05."
                               },
                               {
                                   "assignmentId":  "xiangan-turnback-i-reserve",
                                   "vehicleId":  "trainset-003",
                                   "circulationId":  "C003",
                                   "locationId":  "xiangan-airport",
                                   "operational":  false,
                                   "startTime":  "09:48:00",
                                   "endTime":  "19:36:00",
                                   "sourceTripId":  "00306",
                                   "resumeTripId":  "00501",
                                   "notes":  "00306 enters standby at 09:48; the same vehicle leaves standby at 19:36 and operates passenger trip 00501."
                               }
                           ]
} as const;

